// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cerialNumber div{width:30px}.table-popover-span .el-checkbox{display:block}", ""]);
// Exports
module.exports = exports;
